import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import ChatBox from '../shared/ChatBox'; // Import the ChatBox component

const Application = () => {
    const { applicationId } = useParams();
    const [applicationData, setApplicationData] = useState(null);
    const [showChatBox, setShowChatBox] = useState(false); // State to control chat-box visibility
    const [headPage, setHeadPage] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);

    useEffect(() => {
        const fetchApplicantData = async () => {
            try {
                const response = await axios.get(`/api/recruiter/applications/get-application/${applicationId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                });
                setApplicationData(response.data);
                // console.log('Applicant data:', response.data);
            } catch (error) {
                // console.error('Error fetching applicant data:', error.message);
            }
        };
        setHeadPage('Application');
        fetchApplicantData();
    }, [applicationId]);

    if (!applicationData) {
        return <div>No data</div>;
    }

    const handleSendMessage = () => {
        setShowChatBox(true);
    };

    return (
        <div style={{ background: 'linear-gradient(to bottom right, #f1f7fb, hsl(217, 100%, 97%)'}}>
            <NavHeader />
            <h1>Applicant Details</h1>
            <p><strong>Name:</strong> {applicationData.name}</p>
            <p><strong>Email:</strong> {applicationData.emailOrPhone}</p>
            {applicationData?.resume ?            
                    <p><strong>Resume:</strong> <a href={applicationData?.resume} target="_blank" rel="noopener noreferrer">View Resume</a></p>:
                    <p><strong>Resume:</strong> <i>No Resume Attached</i> </p>}
           <p><strong>Message:</strong> {applicationData.requestMessage}</p>
            <p><strong>Skills:</strong> {applicationData.skills}</p>
            <p><strong>SocialPoints:</strong> {applicationData.socialPoints}</p>
            <p><strong>Education:</strong> {applicationData.education}</p>
            <p><strong>About:</strong> {applicationData.about}</p>
            <p><strong>Status:</strong> {applicationData.status}</p>
            {applicationData.rejectionReasons && applicationData.rejectionReasons.length > 0 &&
                <p><strong>Rejection Reasons:</strong> {applicationData.rejectionReasons.join(' ')}</p>   
            }
            <img title={applicationData.name} style={{width:'100px',height:'100px', borderRadius:'50%'}}
                src={applicationData.profilePicture 
                    ? applicationData.profilePicture.replace('/upload/', '/upload/w_480,h_500,c_fill/') 
                    : '/default-profile.png'}
                alt="Profile"
            />
            <button onClick={handleSendMessage}>Send Message</button> {/* Add message button */}
            
            {showChatBox && (
                <ChatBox
                    recipientId={applicationData.applicantId}
                    recipientName={applicationData.name}
                    onClose={() => setShowChatBox(false)}
                    headPage={headPage}
                />
            )}
        </div>
    );
};

export default Application;